import React from 'react';
import ContactHero from '../components/ContactHero';
import Contact from '../components/Contact';

function ContactPage() {
  return (
    <div className="page">
      <ContactHero />
      <Contact />
    </div>
  );
}

export default ContactPage;
